import { sessionStorageKeyConstants } from '../../constants/session-storage-key-constants'
import { getHeaders } from '../axios/axios-helpers'
import HttpClient from '../axios/http-client'

export async function getOrdersV2(request) {
  const apiPath = `v1/?pageNo=${request.pageNo}&pageSize=${request.pageSize}&sortDirection=${request.sortDirection}&sortProperty=${request.sortProperty}`
  const idToken = sessionStorage.getItem(sessionStorageKeyConstants.ID_TOKEN)
  const headers = getHeaders(idToken)
  const httpClient = new HttpClient(headers)
  return httpClient.shippingInstance().get(apiPath)
}

export async function searchOrdersV2(request) {
  const apiPath = `v1/${request.searchBy}?pageSize=${request.pageSize}&pageNo=${request.pageNo}&sortDirection=${request.sortDirection}&sortProperty=${request.sortProperty}&${request.searchBy}=${request.searchValue}`
  const idToken = sessionStorage.getItem(sessionStorageKeyConstants.ID_TOKEN)
  const headers = getHeaders(idToken)
  const httpClient = new HttpClient(headers)
  return httpClient.shippingInstance().get(apiPath)
}
